/* eslint-disable react/no-array-index-key */
/* eslint-disable react/forbid-prop-types */
import PropTypes from 'prop-types';

import ControllersGroup from '../../../controllers/ControllersGroup';
import {
  SelectController,
  RangeController,
  ChoiceBoxController,
  SimpleColorPickerController,
  ToggleSwitchController,
  GradientColorPickerController,
} from '../../../controllers/Base';

import { getOptionsThemes } from '../../../utils/controllersUtils/themeColors';

const defaultProps = {
  handle: () => {},
  config: undefined,
  data: undefined,
  extend: '',
  setExtend: () => {},
  isGlobalThemeActive: false,
};

const StyleControllers = ({
  handle = defaultProps.handle,
  config = defaultProps.config,
  data = defaultProps.data,
  extend = defaultProps.extend,
  setExtend = defaultProps.setExtend,
  isGlobalThemeActive = defaultProps.isGlobalThemeActive,
}) => {
  const lineOn = Boolean(config?.ExtraLineControl !== 'no-line' && config?.LayoutControl !== 'horizontal');

  const increaseSize = () => {
    let increase = 0;
    if (config?.PalletsControl === 'custom') increase = data?.index?.length ?? 0;
    if (lineOn) increase += 7;
    return increase;
  };

  return (
    <>
      <ControllersGroup
        title="Estilos"
        id="styles"
        extend={extend}
        setExtend={setExtend}
        sizeIncrease={increaseSize()}
      >
        <RangeController
          label="Tamanho da borda de intervalos"
          handle={handle}
          kWord="ExtBorderWidthControl"
          configValue={config?.ExtBorderWidthControl}
          min={0}
          max={20}
          fullWidth
        />
        <ChoiceBoxController
          label="Cor da borda de intervalos"
          handle={handle}
          kWord="ExtBorderColorControl2"
          options={[
            { value: 'brighter', label: 'Clara', id: 'brighter' },
            { value: 'darker', label: 'Escura', id: 'darker' },
            { value: 'custom', label: 'Customizada', id: 'custom' },
          ]}
          configValue={config?.ExtBorderColorControl?.modifiers?.[0]?.[0] || 'custom'}
          fullWidth
          disabled={!config?.ExtBorderWidthControl || config?.ExtBorderWidthControl?.toString() === '0'}
        />
        {typeof config?.ExtBorderColorControl !== 'string' && (
          <RangeController
            label="Opacidade da borda de intervalos"
            handle={handle}
            kWord="ExtBorderOpacityControl"
            configValue={config?.ExtBorderColorControl?.modifiers?.[0]?.[1] || '1'}
            min={0}
            max={2}
            step={0.1}
            precision={1}
            fullWidth
            disabled={!config?.ExtBorderWidthControl || config?.ExtBorderWidthControl?.toString() === '0'}
          />
        )}
        {typeof config?.ExtBorderColorControl === 'string' && (
          <SimpleColorPickerController
            label="Cor customizada"
            handle={handle}
            kWord="ExtBorderColorControl"
            configValue={config?.ExtBorderColorControl}
            orientation="row"
            fullWidth
            disabled={!config?.ExtBorderWidthControl || config?.ExtBorderWidthControl?.toString() === '0'}
          />
        )}
        {config?.MetricTypeControl === 'bar' && (
          <>
            <RangeController
              label="Tamanho da borda da métrica"
              handle={handle}
              kWord="IntBorderWidthControl"
              configValue={config?.IntBorderWidthControl?.value}
              min={0}
              max={20}
              fullWidth
            />
            <ChoiceBoxController
              label="Cor da borda da métrica"
              handle={handle}
              kWord="IntBorderColorControl2"
              options={[
                { value: 'brighter', label: 'Clara', id: 'brighter' },
                { value: 'darker', label: 'Escura', id: 'darker' },
                { value: 'custom', label: 'Customizada', id: 'custom' },
              ]}
              configValue={config?.IntBorderColorControl?.modifiers?.[0]?.[0] || 'custom'}
              fullWidth
              disabled={!config?.IntBorderWidthControl || config?.IntBorderWidthControl?.toString() === '0'}
            />
            {typeof config?.IntBorderColorControl !== 'string' && (
              <RangeController
                label="Opacidade da borda da métrica"
                handle={handle}
                kWord="IntBorderOpacityControl"
                configValue={config?.IntBorderColorControl?.modifiers?.[0]?.[1] || '1'}
                min={0}
                max={2}
                step={0.1}
                precision={1}
                fullWidth
                disabled={!config?.IntBorderWidthControl || config?.IntBorderWidthControl?.toString() === '0'}
              />
            )}
            {typeof config?.IntBorderColorControl === 'string' && (
              <SimpleColorPickerController
                label="Cor customizada"
                handle={handle}
                kWord="IntBorderColorControl"
                configValue={config?.IntBorderColorControl}
                orientation="row"
                fullWidth
                disabled={!config?.IntBorderWidthControl || config?.IntBorderWidthControl?.toString() === '0'}
              />
            )}
          </>
        )}
        <SimpleColorPickerController
          label="Cor da métrica"
          handle={handle}
          kWord="MetricColorControl"
          configValue={config?.MetricColorControl}
          orientation="row"
          fullWidth
        />
        <ChoiceBoxController
          label="Paleta de cores"
          handle={handle}
          kWord="PalletsControl"
          options={[
            { label: 'Padrão', value: 'default', id: 'default' },
            { label: 'Degradê', value: 'gradient', id: 'gradient' },
            { label: 'Customizada', value: 'custom', id: 'custom' },
          ]}
          configValue={config?.PalletsControl}
          fullWidth
          text="Utilizando tema global"
          disabled={config?.UseGlobalColor !== false && isGlobalThemeActive}
        />
        {config?.PalletsControl === 'default' && (
          <SelectController
            label="Tema"
            handle={handle}
            kWord="ColorTheme"
            options={getOptionsThemes()}
            configValue={config?.ColorTheme?.scheme}
            fullWidth
            text="Utilizando tema global"
            disabled={config?.UseGlobalColor !== false && isGlobalThemeActive}
          />
        )}
        {config?.PalletsControl === 'gradient' && (
          <GradientColorPickerController
            handle={handle}
            firstColorVal={config?.GradientPickerControl?.color1 || '#4711B2'}
            firstColorKWord="GradientFirstColor"
            secondColorVal={config?.GradientPickerControl?.color2 || '#FF9626'}
            secondColorKWord="GradientSecondColor"
            thirdColorVal={config?.GradientPickerControl?.color3}
            thirdColorKWord="GradientThirdColor"
            fullWidth
            orientation="row"
            text="Utilizando tema global"
            disabled={config?.UseGlobalColor !== false && isGlobalThemeActive}
          />
        )}
        {config?.PalletsControl === 'custom' && (
          data?.index?.length > 1 && config?.GroupModeControl === 'stacked' ? (
            data?.index?.map((col, i) => {
              const key = typeof col === 'string' ? col : col[col.length - 1];
              if (key === 'Totais') return null;
              return (
                <SimpleColorPickerController
                  dataColorTarget={key.toString()}
                  key={`${key}_i${i}`}
                  label={key}
                  handle={handle}
                  kWord="Colors"
                  configValue={config?.Colors[key]}
                  orientation="row"
                  fullWidth
                  text="Utilizando tema global"
                  disabled={config?.UseGlobalColor !== false && isGlobalThemeActive}
                />
              );
            })
          ) : (
            data?.columns?.map((col, i) => {
              if (col === '_METRICS_') return null;
              return (
                <SimpleColorPickerController
                  dataColorTarget={col.toString()}
                  key={`${col}_i${i}`}
                  label={col}
                  handle={handle}
                  kWord="Colors"
                  configValue={config?.Colors[col]}
                  orientation="row"
                  fullWidth
                  text="Utilizando tema global"
                  disabled={config?.UseGlobalColor !== false && isGlobalThemeActive}
                />
              );
            })
          )
        )}

        <ToggleSwitchController
          label="Utilizar tema global"
          handle={handle}
          kWord="UseGlobalColor"
          configValue={config?.UseGlobalColor}
          firstOption=""
          secondOption=""
          fullWidth
        />
        <ToggleSwitchController
          label="Utilizar fonte global"
          handle={handle}
          kWord="UseGlobalFont"
          configValue={config?.UseGlobalFont}
          firstOption=""
          secondOption=""
          fullWidth
        />
      </ControllersGroup>
    </>
  );
};

StyleControllers.propTypes = {
  config: PropTypes.objectOf(PropTypes.any),
  data: PropTypes.objectOf(PropTypes.any),
  handle: PropTypes.func,
  extend: PropTypes.string,
  setExtend: PropTypes.func,
  isGlobalThemeActive: PropTypes.bool,
};

export default StyleControllers;
